// Only real input in a visible dashboard renews a session. No heartbeat, polling,
// focus event or restored tab counts as activity. One request per five minutes.
export function trackSessionActivity({ target = document, getToken, renew, accept, expire, now = Date.now }) {
  let lastAttempt = -Infinity;
  let pending = false;
  let stopped = false;
  const interval = 5 * 60 * 1000;
  async function activity(event) {
    if (stopped || pending || !event.isTrusted || target.visibilityState !== 'visible') return;
    const token = getToken();
    if (!token || now() - lastAttempt < interval) return;
    lastAttempt = now();
    pending = true;
    try {
      const response = await renew();
      // Signout, a different login, or another tab's renewal wins over this reply.
      if (stopped || getToken() !== token) return;
      if (response.status === 401) { expire(); return; }
      if (!response.ok) return; // Network/server trouble does not end a valid session.
      const data = await response.json();
      if (!stopped && getToken() === token && data?.ok && typeof data.accessToken === 'string' && data.accessToken) accept(data.accessToken);
    } catch { /* Retry on later activity; never extend locally without the server. */ }
    finally { pending = false; }
  }
  const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
  for (const type of events) target.addEventListener(type, activity, { passive: true, capture: true });
  return () => {
    stopped = true;
    for (const type of events) target.removeEventListener(type, activity, { capture: true });
  };
}
